import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function BlogDetail() {
  const { t } = useTranslation();
  const { id } = useParams();

  const articlesData: Record<string, any> = {
    '1': {
      title: 'كيف تبني استراتيجية عمل ناجحة في 2024',
      category: 'إدارة الأعمال',
      image: 'https://public.readdy.ai/ai/img_res/f648ab18b2f018a3d07df75794ba1ef9.jpg',
      author: 'مصطفى محمد',
      date: '15 يناير 2024',
      readTime: '8 دقائق',
      content: `
        <p>في عالم الأعمال المتغير باستمرار، أصبح بناء استراتيجية عمل قوية وفعالة أمراً ضرورياً لنجاح أي مؤسسة. في هذا المقال، سنستعرض الخطوات الأساسية لبناء استراتيجية عمل ناجحة في عام 2024.</p>

        <h2>1. تحليل الوضع الحالي</h2>
        <p>قبل البدء في بناء أي استراتيجية، يجب أن تفهم وضعك الحالي بشكل كامل. قم بتحليل نقاط القوة والضعف في مؤسستك، والفرص والتهديدات في السوق.</p>

        <h2>2. تحديد الرؤية والرسالة</h2>
        <p>الرؤية الواضحة هي البوصلة التي توجه جميع قراراتك الاستراتيجية. يجب أن تكون رؤيتك ملهمة وقابلة للتحقيق في نفس الوقت.</p>

        <h2>3. وضع الأهداف الاستراتيجية</h2>
        <p>حدد أهدافاً واضحة وقابلة للقياس. استخدم منهجية SMART لضمان أن أهدافك محددة، قابلة للقياس، قابلة للتحقيق، ذات صلة، ومحددة بإطار زمني.</p>

        <h2>4. تطوير خطة العمل</h2>
        <p>حول أهدافك الاستراتيجية إلى خطوات عملية قابلة للتنفيذ. حدد المسؤوليات والموارد المطلوبة والجداول الزمنية.</p>

        <h2>5. المتابعة والتقييم</h2>
        <p>الاستراتيجية ليست وثيقة ثابتة. يجب مراجعتها وتحديثها بانتظام بناءً على التغيرات في السوق والأداء الفعلي.</p>

        <h2>الخلاصة</h2>
        <p>بناء استراتيجية عمل ناجحة يتطلب تخطيطاً دقيقاً وتنفيذاً منضبطاً ومتابعة مستمرة. باتباع هذه الخطوات، ستكون في طريقك لتحقيق النجاح المستدام لمؤسستك.</p>
      `
    },
    '2': {
      title: 'التحول الرقمي: خطوات عملية للمؤسسات',
      category: 'التقنية',
      image: 'https://readdy.ai/api/search-image?query=digital%20transformation%20with%20modern%20technology%20and%20innovative%20systems%2C%20clean%20minimalist%20background%2C%20professional%20tech%20environment%2C%20high%20quality%20photography&width=1200&height=600&seq=blogdetail2&orientation=landscape',
      author: 'أحمد السعيد',
      date: '12 يناير 2024',
      readTime: '10 دقائق',
      content: `
        <p>التحول الرقمي لم يعد خياراً، بل أصبح ضرورة حتمية لأي مؤسسة تسعى للبقاء والمنافسة في السوق الحديث. في هذا المقال، نستعرض الخطوات العملية للتحول الرقمي الناجح.</p>

        <h2>ما هو التحول الرقمي؟</h2>
        <p>التحول الرقمي هو عملية دمج التقنية الرقمية في جميع جوانب العمل، مما يؤدي إلى تغييرات جوهرية في طريقة العمل وتقديم القيمة للعملاء.</p>

        <h2>الخطوات الأساسية للتحول الرقمي</h2>
        
        <h3>1. تقييم الوضع الحالي</h3>
        <p>ابدأ بتقييم شامل للأنظمة والعمليات الحالية. حدد المجالات التي تحتاج إلى تحسين والفرص المتاحة للتطوير.</p>

        <h3>2. وضع استراتيجية واضحة</h3>
        <p>حدد أهدافك من التحول الرقمي وكيف سيساهم في تحقيق أهداف المؤسسة العامة.</p>

        <h3>3. بناء الثقافة الرقمية</h3>
        <p>التحول الرقمي ليس فقط عن التقنية، بل عن تغيير ثقافة المؤسسة. استثمر في تدريب الموظفين وبناء ثقافة الابتكار.</p>

        <h3>4. اختيار التقنيات المناسبة</h3>
        <p>اختر الحلول التقنية التي تناسب احتياجاتك وميزانيتك. لا تنساق وراء التقنيات الحديثة دون دراسة جدواها.</p>

        <h3>5. التنفيذ التدريجي</h3>
        <p>ابدأ بمشاريع صغيرة وقابلة للإدارة، ثم توسع تدريجياً. هذا يقلل المخاطر ويسمح بالتعلم من التجربة.</p>

        <h2>التحديات الشائعة</h2>
        <p>من أبرز التحديات: مقاومة التغيير، نقص المهارات الرقمية، وقيود الميزانية. التخطيط الجيد والتواصل الفعال يساعدان في التغلب على هذه التحديات.</p>

        <h2>الخلاصة</h2>
        <p>التحول الرقمي رحلة مستمرة وليس وجهة نهائية. بالتخطيط السليم والتنفيذ المنضبط، يمكن لأي مؤسسة تحقيق النجاح في هذه الرحلة.</p>
      `
    },
    '3': {
      title: 'استراتيجيات التسويق الرقمي الفعالة',
      category: 'التسويق',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20strategy%20with%20social%20media%20and%20analytics%2C%20clean%20modern%20background%2C%20professional%20marketing%20workspace%2C%20high%20quality%20photography&width=1200&height=600&seq=blogdetail3&orientation=landscape',
      author: 'فاطمة الزهراني',
      date: '10 يناير 2024',
      readTime: '7 دقائق',
      content: `
        <p>في عصر التحول الرقمي، أصبح التسويق الرقمي أداة أساسية لنجاح أي عمل تجاري. في هذا المقال، نستعرض أهم الاستراتيجيات التي يمكن أن تحدث فرقاً حقيقياً في نتائجك التسويقية.</p>

        <h2>1. تحسين محركات البحث (SEO)</h2>
        <p>تحسين موقعك لمحركات البحث يضمن ظهورك في النتائج الأولى عندما يبحث العملاء المحتملون عن خدماتك. استثمر في المحتوى الجيد والكلمات المفتاحية المناسبة.</p>

        <h2>2. التسويق عبر وسائل التواصل الاجتماعي</h2>
        <p>اختر المنصات المناسبة لجمهورك المستهدف. لا تحاول التواجد في كل مكان، بل ركز على المنصات التي يتواجد فيها عملاؤك.</p>

        <h2>3. التسويق بالمحتوى</h2>
        <p>المحتوى القيم يجذب العملاء ويبني الثقة. أنشئ محتوى يحل مشاكل جمهورك ويجيب على أسئلتهم.</p>

        <h2>4. التسويق عبر البريد الإلكتروني</h2>
        <p>رغم قدمه، لا يزال البريد الإلكتروني من أكثر قنوات التسويق فعالية. بناء قائمة بريدية قوية واستخدامها بذكاء يمكن أن يحقق نتائج مذهلة.</p>

        <h2>5. الإعلانات المدفوعة</h2>
        <p>الإعلانات المدفوعة على جوجل ووسائل التواصل الاجتماعي توفر نتائج سريعة. لكن تأكد من استهداف الجمهور المناسب وقياس النتائج باستمرار.</p>

        <h2>قياس النتائج</h2>
        <p>استخدم أدوات التحليل لقياس أداء حملاتك. البيانات هي مفتاح التحسين المستمر.</p>

        <h2>الخلاصة</h2>
        <p>التسويق الرقمي الناجح يتطلب استراتيجية متكاملة تجمع بين عدة قنوات وأساليب. ابدأ بما يناسب ميزانيتك وتوسع تدريجياً.</p>
      `
    }
  };

  const article = articlesData[id || '1'] || articlesData['1'];

  const relatedArticles = [
    {
      id: 2,
      title: 'التحول الرقمي: خطوات عملية للمؤسسات',
      image: 'https://readdy.ai/api/search-image?query=digital%20transformation%20technology%2C%20clean%20background%2C%20professional%20environment%2C%20high%20quality&width=400&height=250&seq=related1&orientation=landscape'
    },
    {
      id: 3,
      title: 'استراتيجيات التسويق الرقمي الفعالة',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20strategy%2C%20clean%20background%2C%20professional%20workspace%2C%20high%20quality&width=400&height=250&seq=related2&orientation=landscape'
    },
    {
      id: 4,
      title: 'تطوير الموارد البشرية في العصر الحديث',
      image: 'https://readdy.ai/api/search-image?query=HR%20development%20training%2C%20clean%20background%2C%20professional%20environment%2C%20high%20quality&width=400&height=250&seq=related3&orientation=landscape'
    }
  ].filter(a => a.id.toString() !== id);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src={article.image} 
            alt={article.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-white">
            <span className="inline-block bg-blue-600 px-4 py-2 rounded-lg font-semibold mb-6">
              {article.category}
            </span>
            <h1 className="text-5xl font-bold mb-6 leading-tight">{article.title}</h1>
            <div className="flex flex-wrap items-center gap-6 text-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-user-line text-xl"></i>
                </div>
                <span className="font-semibold">{article.author}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>{article.date}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>{article.readTime}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div 
              className="prose prose-lg max-w-none"
              style={{
                fontSize: '1.125rem',
                lineHeight: '1.8',
                color: '#374151'
              }}
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            {/* Share Section */}
            <div className="mt-16 pt-8 border-t-2 border-gray-200">
              <h3 className="text-xl font-bold text-gray-800 mb-4">شارك المقال</h3>
              <div className="flex items-center gap-4">
                <button className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </button>
                <button className="w-12 h-12 flex items-center justify-center bg-blue-400 text-white rounded-full hover:bg-blue-500 transition-colors cursor-pointer">
                  <i className="ri-twitter-fill text-xl"></i>
                </button>
                <button className="w-12 h-12 flex items-center justify-center bg-blue-700 text-white rounded-full hover:bg-blue-800 transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </button>
                <button className="w-12 h-12 flex items-center justify-center bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors cursor-pointer">
                  <i className="ri-whatsapp-fill text-xl"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {relatedArticles.length > 0 && (
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">مقالات ذات صلة</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {relatedArticles.map((related) => (
                  <Link 
                    key={related.id}
                    to={`/blog/${related.id}`}
                    className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all group cursor-pointer"
                  >
                    <div className="relative h-48 w-full overflow-hidden">
                      <img 
                        src={related.image} 
                        alt={related.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="text-lg font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
                        {related.title}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
}